var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey,staticClass:"container v-content-container tooltip-wrapper"},[_c('div',{staticClass:"row tooltip-wrapper"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_c('i',{staticClass:"fa fa-fw fa-lg fa-cubes"}),_vm._v(" "+_vm._s(_vm.$label("inventory.inventory_management", "Inventory management"))+" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.$label('inventory.new_inventory', 'New inventory'),
            classes: 'custom-tooltip'
          }),expression:"{\n            content: $label('inventory.new_inventory', 'New inventory'),\n            classes: 'custom-tooltip'\n          }"}],staticClass:"btn btn-v-lightgreen-white pull-right",attrs:{"to":{ name: 'NewInventoryProduct' }}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-plus"})]),_c('select',{staticClass:"form-control header-select pull-right",staticStyle:{"margin-right":"15px"},attrs:{"id":"inventory-group-select"}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$label("inventory.all_locations", "All locations")))]),_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$label("inventory.facility_name", "Facility name")))])])],1)])]),_vm._m(0),_c('alert-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.failedRequest),expression:"failedRequest"}],attrs:{"type":"warning","closeable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label( "inventory.inventory_products_failed_request", "Request failed while loading inventory products." ))+" ")]),_c('Table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failedRequest),expression:"!failedRequest"}],attrs:{"id":"inventory-products-table","loading":_vm.loading,"columns":[
      {
        title: 'Name',
        field: 'name',
        id: function (row) { return ("inventory-item-name-" + (row.id)); },
        sorting: true
      },
      {
        title: 'Locations',
        id: function (row) { return ("inventory-item-locations-" + (row.id)); },
        value: function (row) { return row.facilities
            .map(
              function (facility) { return ((facility.address.city) + " " + (facility.address.post_code)); }
            )
            .join(', '); }
      },
      {
        title: 'Amount',
        field: 'max_available_units',
        id: function (row) { return ("inventory-item-amount-" + (row.id)); }
      },
      {
        title: 'Price',
        id: function (row) { return ("inventory-item-price-" + (row.id)); },
        value: function (row) { return row.price.form === 'gross'
            ? row.price.amount_gross
            : row.price.amount_net; }
      }
    ],"actions":[
      {
        type: 'detail',
        onClick: function (row) {
          _vm.$router.push({
            name: 'InventoryProductDetails',
            params: { inventory_product_id: row.id }
          });
        }
      },
      {
        type: 'delete',
        id: function (row) { return ("delete-inventory-item-button-" + (row.id)); },
        onClick: function (row) { return _vm.deleteInventoryProduct(row.id); }
      }
    ],"data":_vm.inventoryProducts,"meta":_vm.metaData},on:{"fetchQuery":function (params) {
        _vm.fetchParams = params;
        _vm.getInventoryProducts({
          //
        });
      }}},[_c('div',{staticClass:"btn-group",staticStyle:{"margin-left":"5px"},attrs:{"slot":"toolbar","id":"action-dropdown"},slot:"toolbar"},[_c('button',{staticClass:"btn btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "+_vm._s(_vm.$label("common.actions", "Actions"))+" "),_c('span',{staticClass:"caret"})]),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NewInventoryProduct' }}},[_c('i',{staticClass:"text-primary fa fa-fw fa-lg fa-plus"}),_vm._v(" "+_vm._s(_vm.$label("inventory.create_new_inventory", "Create new inventory")))])],1)])])]),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-8"},[_c('div',{staticClass:"col-xs-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-8"},[_c('div',{staticClass:"col-xs-12"})])}]

export { render, staticRenderFns }